import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { LogoMark } from "@/components/landing/Logo";

export default function PaymentCancel() {
    return (
        <div className="grain relative flex min-h-screen items-center justify-center bg-[linear-gradient(135deg,#0C2A52,#071731)] px-4 py-16">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl sm:p-10"
                data-testid="payment-cancel-card"
            >
                <div className="mx-auto w-fit">
                    <LogoMark size={48} />
                </div>
                <XCircle className="mx-auto mt-8 h-12 w-12 text-slate-300" />
                <h1 className="mt-5 font-display text-2xl font-extrabold text-navy-950">Pagamento annullato</h1>
                <p className="mt-3 text-sm leading-relaxed text-slate-500">
                    Nessun addebito è stato effettuato. Puoi riprendere l'acquisto quando vuoi: le 3 simulazioni ti
                    aspettano.
                </p>
                <Link
                    to="/"
                    data-testid="cancel-back-home-btn"
                    className="mt-8 inline-flex w-full items-center justify-center rounded-lg bg-gold px-7 py-4 font-bold text-navy-950 transition-[background-color] duration-300 hover:bg-gold-hover"
                >
                    Torna alla pagina principale
                </Link>
            </motion.div>
        </div>
    );
}
